<template>
  <div class="scenery-box">
    <div class="box box1" @click="notifyParent"></div>
    <div class="box box2" @click="notifyParent"></div>
    <div class="box box3" @click="notifyParent"></div>
    <div class="box box4" @click="notifyParent"></div>
    <div class="box box5" @click="notifyParent"></div>
    <div class="box box6" @click="notifyParent"></div>
    <div class="box box7" @click="notifyParent"></div>
    <div class="box box8" @click="notifyParent"></div>
    <div class="box box9" @click="notifyParent"></div>
    <div class="box box10" @click="notifyParent"></div>
    <div class="box box11" @click="notifyParent"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    notifyParent() {
      // 触发自定义事件 'child-click'，并传递一些数据
      this.$emit("child-click", "Some data");
      console.log("123");
    },
  },
};
</script>
<style lang="less" scoped>
.scenery-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: url(~@/assets/goplay/all.png) no-repeat center center;
  // pointer-events: none;

  display: block;
  pointer-events: none;
  background: url(https://xld-project-static.oss-cn-hangzhou.aliyuncs.com/xld/theme/song/index/ming_map.jpg)
    no-repeat;
  background-size: cover;
  .box {
    width: 200px;
    height: 200px;
    background: transparent;
    cursor: pointer;
    pointer-events: auto;
    position: absolute;
  }
  .box1 {
    width: 260px;
    left: 8vh;
    top: 15vh;
  }
  .box2 {
    height: 400px;
    left: 15vh;
    top: 44vh;
  }
  .box3 {
    height: 280px;
    left: 46vh;
    top: 32vh;
  }
  .box4 {
    height: 300px;
    left: 85vh;
    top: 60vh;
  }
  .box5 {
    left: 130vh;
    top: 70vh;
  }
  .box6 {
    left: 82vh;
    top: 10vh;
  }
  .box7 {
    left: 135vh;
    top: 13vh;
  }
  .box8 {
    width: 300px;
    left: 116vh;
    top: 40vh;
  }
  .box9 {
    left: 162vh;
    top: 48vh;
  }
  .box10 {
    left: 170vh;
    top: 26vh;
  }
  .box11 {
    left: 165vh;
    top: 3vh;
  }
}
</style>
